"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressFinder = exports.setup = exports.Finder = exports.defaultConfig = void 0;
// this is the default test key
// it is rate limited, usage limited and the results returned are not complete
// this is so you are not tempted to use this for real in production
// signup for your own free evaluation key here:
// https://rapidapi.com/knocode-knocode-default/api/uk-address-and-postcodes/pricing
var testKeyPart1 = '3c2614289fmsh0cff20e0f';
var testKeyPart2 = '4126f9p18c4e7jsn64a562f6d771';
// testKey split like this to stop gitguardian complaining about keys in the source code
var testKey = testKeyPart1 + testKeyPart2;
exports.defaultConfig = {
    inputField: '',
    apiKey: testKey,
    baseUrl: 'https://uk-address-and-postcodes.p.rapidapi.com',
    onAddressRetrieved: function () {
        return {};
    },
    listClass: 'knocode-suggestion-list',
    containerClass: 'knocode-suggestion-container',
    outputFields: {},
};
var Key;
(function (Key) {
    Key[Key["Enter"] = 13] = "Enter";
    Key[Key["ArrowUp"] = 38] = "ArrowUp";
    Key[Key["ArrowDown"] = 40] = "ArrowDown";
    Key[Key["Escape"] = 27] = "Escape";
    Key[Key["DontCare"] = 0] = "DontCare";
})(Key || (Key = {}));
var defaultStyle = 'div.knocode-suggestion-container {\n' +
    '    position: relative;\n' +
    '    margin: 0;\n' +
    '    padding: 0;\n' +
    '    border: 0\n' +
    '}\n' +
    'div.knocode-suggestion-container > input {\n' +
    '    display: block\n' +
    '}\n' +
    'div.knocode-suggestion-container > ul {\n' +
    '    position: absolute;\n' +
    '    left: 0;\n' +
    '    z-index: 1;\n' +
    '    min-width: 100%;\n' +
    '    box-sizing: border-box;\n' +
    '    list-style: none;\n' +
    '    padding: 0;\n' +
    '    border-radius: 0.3em;\n' +
    '    margin: 0.2em 0 0;\n' +
    '    background: #fff;\n' +
    '    border: 1px solid rgba(0, 0, 0, 0.3);\n' +
    '    box-shadow: 0.05em 0.2em 0.6em rgba(0, 0, 0, 0.2);\n' +
    '    text-shadow: none;\n' +
    '    max-height: 250px;\n' +
    '    overflow-y: scroll\n' +
    '}\n' +
    'div.knocode-suggestion-container > ul > li {\n' +
    '    position: relative;\n' +
    '    padding: 0.2em 0.5em;\n' +
    '    cursor: pointer\n' +
    '}\n' +
    'div.knocode-suggestion-container > ul > li:hover {\n' +
    '    background: #b8d3e0;\n' +
    '    color: black\n' +
    '}\n' +
    'div.knocode-suggestion-container > ul > li[aria-selected="true"] {\n' +
    '    background: #3d6d8f;\n' +
    '    color: white\n' +
    '}\n' +
    'li.knocode-watermark {\n' +
    '    float: right;\n' +
    '    font-size: small;\n' +
    '    margin-right: 10px;\n' +
    '}\n' +
    '@supports (transform:scale(0)) {\n' +
    '    div.knocode-suggestion-container > ul {\n' +
    '        transition: 0.3s cubic-bezier(0.4, 0.2, 0.5, 1.4);\n' +
    '        transform-origin: 1.43em -0.43em\n' +
    '    }\n' +
    '    div.knocode-suggestion-container > ul[hidden], div.knocode-suggestion-container > ul:empty {\n' +
    '        opacity: 0;\n' +
    '        transform: scale(0);\n' +
    '        display: block;\n' +
    '        transition-timing-function: ease\n' +
    '    }\n' +
    '}';
var Finder = /** @class */ (function () {
    function Finder(userConfig) {
        this.selectedIndex = 0;
        this.showWatermark = false;
        this.config = __assign(__assign({}, exports.defaultConfig), userConfig);
        if (!this.config.inputField || this.config.inputField == '')
            throw "Input field hasn't been defined";
        if (typeof this.config.inputField == 'string') {
            var foundField = window.document.querySelector(this.config.inputField);
            if (!foundField)
                throw "Didn't find input field with the selector " + this.config.inputField;
            this.inputField = foundField;
        }
        else
            this.inputField = this.config.inputField;
        this.document = this.inputField.ownerDocument;
        this.suggestionList = this.createSuggestionList(this.document, this.config.listClass);
        this.container = this.createContainer(this.document, this.config.containerClass);
        this.attach(this.inputField, this.suggestionList, this.container);
        this.injectStyle(this.document, defaultStyle);
        if (this.config.apiKey == testKey)
            console.warn("Address-finder is using the test key, do not use this key in production.  The results from the API calls are intentionally incomplete.");
    }
    Finder.prototype.setSuggestions = function (value, suggestions) {
        var _this = this;
        var currentValue = this.inputField.value.trim();
        if (value != currentValue)
            return; // ignore old response received
        this.suggestionList.innerHTML = '';
        var items = suggestions.result.hits.map(function (c) {
            var li = _this.document.createElement('li');
            li.textContent = c.suggestion;
            li.setAttribute('data-id', c.addressId.toString());
            return li;
        });
        items.forEach(function (item) { return _this.suggestionList.appendChild(item); });
        if (items.length > 0 && this.showWatermark) {
            var watermark = this.document.createElement('li');
            watermark.innerHTML = "Brought to you by Knocode.com";
            watermark.className = "knocode-watermark";
            this.suggestionList.appendChild(watermark);
        }
        this.suggestionList.style.display = 'block';
        this.selectedIndex = 0;
        this.scrollSuggestionIntoView(0);
    };
    Finder.prototype.onInput = function () {
        return __awaiter(this, void 0, void 0, function () {
            var value, suggestions, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        value = this.inputField.value.trim();
                        if (!(value.length == 0)) return [3 /*break*/, 1];
                        this.suggestionList.innerHTML = '';
                        this.hideSuggestionList();
                        return [2 /*return*/];
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.callApi("/rapidapi/v1/autocomplete/addresses?query=" + value)];
                    case 2:
                        suggestions = _a.sent();
                        this.setSuggestions(value, suggestions);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.log(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Finder.prototype.onBlur = function () {
        this.hideSuggestionList();
    };
    Finder.prototype.onFocus = function () {
        this.showSuggestionList();
    };
    Finder.prototype.toKey = function (code) {
        switch (code) {
            case 13:
                return Key.Enter;
            case 38:
                return Key.ArrowUp;
            case 40:
                return Key.ArrowDown;
            case 27:
                return Key.Escape;
            default:
                return Key.DontCare;
        }
    };
    Finder.prototype.scrollSuggestionIntoView = function (n) {
        if (n < 0 || n >= this.suggestionList.children.length)
            return;
        var li = this.suggestionList.children[n];
        var liOffset = li.offsetTop;
        var ulScrollTop = this.suggestionList.scrollTop;
        if (liOffset < ulScrollTop)
            this.suggestionList.scrollTop = liOffset;
        var ulHeight = this.suggestionList.clientHeight;
        var liHeight = li.clientHeight;
        if (liOffset + liHeight > ulScrollTop + ulHeight)
            this.suggestionList.scrollTop = liOffset - ulHeight + liHeight;
        for (var _i = 0, _a = Array.from(this.suggestionList.children); _i < _a.length; _i++) {
            var item = _a[_i];
            item.setAttribute('aria-selected', (li == item).toString());
        }
    };
    Finder.prototype.nextSuggestion = function () {
        this.selectedIndex = (this.selectedIndex + 1) % this.suggestionList.children.length;
        this.scrollSuggestionIntoView(this.selectedIndex);
    };
    Finder.prototype.prevSuggestion = function () {
        this.selectedIndex = this.selectedIndex - 1;
        if (this.selectedIndex < 0)
            this.selectedIndex = this.suggestionList.children.length - 1;
        this.scrollSuggestionIntoView(this.selectedIndex);
    };
    Finder.prototype.hideSuggestionList = function () {
        this.suggestionList.style.display = 'none';
    };
    Finder.prototype.showSuggestionList = function () {
        if (this.suggestionList.children.length > 0)
            this.suggestionList.style.display = 'block';
    };
    Finder.prototype.getOutputFieldAsElement = function (destination) {
        if (typeof destination == 'string') {
            var elementOrNull = this.document.querySelector(destination);
            if (!elementOrNull)
                console.log("Cannot populate " + destination + " because the element with that selector cannot be found on the page");
            return elementOrNull;
        }
        else
            return destination;
    };
    Finder.prototype.updateTextInElement = function (element, text) {
        if (element instanceof HTMLInputElement) {
            element.value = text;
        }
        else if (element instanceof HTMLTextAreaElement) {
            element.value = text;
        }
        else if (element instanceof HTMLSpanElement) {
            element.innerText = text;
        }
        else if (element instanceof HTMLParagraphElement) {
            element.innerText = text;
        }
        else
            console.log("Not setting the value for element " + element.id + " because it isn't a input, text area, span or paragraph");
    };
    Finder.prototype.updateOutputFieldsWithAddress = function (address) {
        var outputFieldsKey;
        for (outputFieldsKey in this.config.outputFields) {
            if (!Object.prototype.hasOwnProperty.call(this.config.outputFields, outputFieldsKey))
                continue;
            if (!(outputFieldsKey in address)) {
                console.log("Not populating " + outputFieldsKey + " because it isn't a field in an Address");
                continue;
            }
            var destination = this.config.outputFields[outputFieldsKey];
            if (!destination)
                continue;
            var element = this.getOutputFieldAsElement(destination);
            if (!element)
                continue;
            this.updateTextInElement(element, address[outputFieldsKey]);
        }
    };
    Finder.prototype.chooseSuggestion = function (li) {
        return __awaiter(this, void 0, void 0, function () {
            var addressId, addressResponse, address, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        addressId = li.getAttribute('data-id');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.callApi("/rapidapi/v1/address/" + addressId)];
                    case 2:
                        addressResponse = _a.sent();
                        this.hideSuggestionList();
                        address = addressResponse.result;
                        this.config.onAddressRetrieved(address);
                        this.updateOutputFieldsWithAddress(address);
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        console.log(e_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Finder.prototype.chooseSuggestionWithIndex = function (n) {
        return __awaiter(this, void 0, void 0, function () {
            var li;
            return __generator(this, function (_a) {
                if (n < 0 || n > this.suggestionList.children.length)
                    return [2 /*return*/];
                li = this.suggestionList.children[n];
                return [2 /*return*/, this.chooseSuggestion(li)];
            });
        });
    };
    Finder.prototype.onKeydown = function (event) {
        var key = this.toKey(event.keyCode);
        switch (key) {
            case Key.ArrowDown:
                this.nextSuggestion();
                break;
            case Key.ArrowUp:
                this.prevSuggestion();
                break;
            case Key.Escape:
                this.hideSuggestionList();
                break;
            case Key.Enter:
                this.chooseSuggestionWithIndex(this.selectedIndex);
        }
    };
    Finder.prototype.attach = function (inputField, suggestionList, container) {
        var _this = this;
        inputField.addEventListener('input', function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.onInput()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        inputField.addEventListener('blur', function () { return _this.onBlur(); });
        inputField.addEventListener('focus', function () { return _this.onFocus(); });
        inputField.addEventListener('keydown', function (e) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.onKeydown(e)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); });
        inputField.setAttribute('autocomplete', 'none');
        inputField.setAttribute('autocorrect', 'off');
        inputField.setAttribute('autocapitalize', 'off');
        inputField.setAttribute('spellcheck', 'false');
        var parent = inputField.parentNode;
        if (!parent)
            throw 'Expected Input field to have parent';
        parent.insertBefore(container, inputField);
        container.appendChild(inputField);
        container.appendChild(suggestionList);
    };
    Finder.prototype.injectStyle = function (document, css) {
        var style = document.createElement('style');
        style.type = 'text/css';
        style.appendChild(document.createTextNode(css));
        document.head.appendChild(style);
    };
    Finder.prototype.mouseDown = function (e) {
        var li = e.target;
        return this.chooseSuggestion(li);
    };
    Finder.prototype.createSuggestionList = function (document, className) {
        var _this = this;
        var list = document.createElement('ul');
        list.className = className;
        list.style.display = 'none';
        list.addEventListener("mousedown", function (e) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this.mouseDown(e)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); });
        return list;
    };
    Finder.prototype.createContainer = function (document, className) {
        var container = document.createElement('div');
        container.className = className;
        return container;
    };
    Finder.prototype.callApi = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var response, moreInfo, hint;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch("" + this.config.baseUrl + url, {
                            headers: new Headers({ "x-rapidapi-key": this.config.apiKey })
                        })];
                    case 1:
                        response = _a.sent();
                        if (!!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.text()];
                    case 2:
                        moreInfo = _a.sent();
                        hint = "Failed calling Knocode address API, status code: " + response.status + ", details: " + moreInfo;
                        console.log(hint);
                        throw hint;
                    case 3:
                        this.showWatermark = this.config.apiKey == testKey;
                        return [2 /*return*/, response.json()];
                }
            });
        });
    };
    return Finder;
}());
exports.Finder = Finder;
var setup = function (config) {
    return new Finder(config);
};
exports.setup = setup;
exports.AddressFinder = { setup: exports.setup };
//# sourceMappingURL=index.js.map